export default "mutation SubmitForm($request:CustomerRequest!){createCustomerRequest(request:$request)}"